/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from "react";
import { useGLTF, useAnimations, Float, Box } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { state } from "./store";
import { useSnapshot } from "valtio";
export default function Birds(props) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF("/bird.glb");
  const { actions, names } = useAnimations(animations, group);
  const { finishedIntro } = useSnapshot(state);

  // console.log(actions)

  useEffect(() => {
    animations.forEach((item) => {
      actions[item.name].play();
      actions[item.name].loop = true;
      actions[item.name].timeScale = 1.8;
    });
  });

  useFrame(({ clock }) => {
    if (!finishedIntro) return;
    group.current.position.x += 0.18;
    if (group.current.position.x > 255) {
      group.current.position.x = -235;
    }
  });

  return (
    <group
      ref={group}
      {...props}
      visible={finishedIntro}
      rotation={[0, 1.57, 0]}
      position={[-35, 40, 50]}
      scale={0.15}
      dispose={null}
    >
      <Float
        floatIntensity={20}
        speed={2}
        rotationIntensity={2}
        floatingRange={[-3, 2]}
      >
        <group name="Scene">
          <group
            name="Bird"
            position={[0.47, 2.38, 1.51]}
            rotation={[0.05, 0.03, 0.03]}
          >
            <mesh
              name="lwing"
              castShadow
              receiveShadow
              geometry={nodes.lwing.geometry}
              material={materials.Material}
              position={[1.16, 0, 0]}
            />
            <mesh
              name="rwing"
              castShadow
              receiveShadow
              geometry={nodes.rwing.geometry}
              material={materials.Material}
              position={[-1.35, 0, 0]}
            />
            <mesh
              name="body"
              castShadow
              receiveShadow
              geometry={nodes.body.geometry}
              material={materials.Material}
              position={[-0.09, 0, -1.68]}
              scale={5.88}
            />
          </group>
          <group
            name="Bird001"
            position={[-8.75, 0.15, -15.79]}
            rotation={[0, 0.23, 0]}
          >
            <mesh
              name="lwing001"
              castShadow
              receiveShadow
              geometry={nodes.lwing001.geometry}
              material={materials.Material}
              position={[1.16, 0, 0]}
            />
            <mesh
              name="rwing001"
              castShadow
              receiveShadow
              geometry={nodes.rwing001.geometry}
              material={materials.Material}
              position={[-1.35, 0, 0]}
            />
            <mesh
              name="body001"
              castShadow
              receiveShadow
              geometry={nodes.body001.geometry}
              material={materials.Material}
              position={[-0.09, 0, -1.68]}
              scale={5.88}
            />
          </group>
          <group name="Bird002" position={[17.39, 1.49, -16.16]}>
            <mesh
              name="rwing002"
              castShadow
              receiveShadow
              geometry={nodes.rwing002.geometry}
              material={materials.Material}
              position={[-1.35, 0, 0]}
            />
            <mesh
              name="lwing002"
              castShadow
              receiveShadow
              geometry={nodes.lwing002.geometry}
              material={materials.Material}
              position={[1.16, 0, 0]}
            />
            <mesh
              name="body002"
              castShadow
              receiveShadow
              geometry={nodes.body002.geometry}
              material={materials.Material}
              position={[-0.09, 0, -1.68]}
              scale={5.88}
            />
          </group>
          <group
            name="Bird003"
            position={[8.9, -3.36, -31.72]}
            rotation={[0.05, -0.1, 0.03]}
          >
            <mesh
              name="lwing003"
              castShadow
              receiveShadow
              geometry={nodes.lwing003.geometry}
              material={materials.Material}
              position={[1.16, 0, 0]}
            />
            <mesh
              name="rwing003"
              castShadow
              receiveShadow
              geometry={nodes.rwing003.geometry}
              material={materials.Material}
              position={[-1.35, 0, 0]}
            />
            <mesh
              name="body003"
              castShadow
              receiveShadow
              geometry={nodes.body003.geometry}
              material={materials.Material}
              position={[-0.09, 0, -1.68]}
              scale={5.88}
            />
          </group>
          <group
            name="Bird004"
            position={[-14.92, -3.06, -38.51]}
            rotation={[0.05, 0.03, 0.03]}
          >
            <mesh
              name="lwing004"
              castShadow
              receiveShadow
              geometry={nodes.lwing004.geometry}
              material={materials.Material}
              position={[1.16, 0, 0]}
            />
            <mesh
              name="rwing004"
              castShadow
              receiveShadow
              geometry={nodes.rwing004.geometry}
              material={materials.Material}
              position={[-1.35, 0, 0]}
            />
            <mesh
              name="body004"
              castShadow
              receiveShadow
              geometry={nodes.body004.geometry}
              material={materials.Material}
              position={[-0.09, 0, -1.68]}
              scale={5.88}
            />
          </group>
          <group name="Bird005" position={[28.46, 3.3, -34.13]}>
            <mesh
              name="lwing005"
              castShadow
              receiveShadow
              geometry={nodes.lwing005.geometry}
              material={materials.Material}
              position={[1.16, 0, 0]}
            />
            <mesh
              name="body005"
              castShadow
              receiveShadow
              geometry={nodes.body005.geometry}
              material={materials.Material}
              position={[-0.09, 0, -1.68]}
              scale={5.88}
            />
            <mesh
              name="rwing005"
              castShadow
              receiveShadow
              geometry={nodes.rwing005.geometry}
              material={materials.Material}
              position={[-1.35, 0, 0]}
            />
          </group>
          <group
            name="Bird006"
            position={[88.99, -12.45, -63.49]}
            rotation={[0.05, 0.03, 0.03]}
          >
            <mesh
              name="rwing006"
              castShadow
              receiveShadow
              geometry={nodes.rwing006.geometry}
              material={materials.Material}
              position={[-1.35, 0, 0]}
            />
            <mesh
              name="lwing006"
              castShadow
              receiveShadow
              geometry={nodes.lwing006.geometry}
              material={materials.Material}
              position={[1.16, 0, 0]}
            />
            <mesh
              name="body006"
              castShadow
              receiveShadow
              geometry={nodes.body006.geometry}
              material={materials.Material}
              position={[-0.09, 0, -1.68]}
              scale={5.88}
            />
          </group>
          <group
            name="Bird007"
            position={[55.36, -2.76, -49.72]}
            rotation={[0.05, 0.03, 0.03]}
          >
            <mesh
              name="rwing007"
              castShadow
              receiveShadow
              geometry={nodes.rwing007.geometry}
              material={materials.Material}
              position={[-1.35, 0, 0]}
            />
            <mesh
              name="lwing007"
              castShadow
              receiveShadow
              geometry={nodes.lwing007.geometry}
              material={materials.Material}
              position={[1.16, 0, 0]}
            />
            <mesh
              name="body007"
              castShadow
              receiveShadow
              geometry={nodes.body007.geometry}
              material={materials.Material}
              position={[-0.09, 0, -1.68]}
              scale={5.88}
            />
          </group>
          <group
            name="Bird008"
            position={[-31.65, 1.51, -30.99]}
            rotation={[0.05, 0.22, 0.03]}
          >
            <mesh
              name="lwing008"
              castShadow
              receiveShadow
              geometry={nodes.lwing008.geometry}
              material={materials.Material}
              position={[1.16, 0, 0]}
            />
            <mesh
              name="rwing008"
              castShadow
              receiveShadow
              geometry={nodes.rwing008.geometry}
              material={materials.Material}
              position={[-1.35, 0, 0]}
            />
            <mesh
              name="body008"
              castShadow
              receiveShadow
              geometry={nodes.body008.geometry}
              material={materials.Material}
              position={[-0.09, 0, -1.68]}
              scale={5.88}
            />
          </group>
          <group
            name="Bird009"
            position={[-30.25, 0.65, -83.3]}
            rotation={[0.05, 0.03, 0.03]}
          >
            <mesh
              name="lwing009"
              castShadow
              receiveShadow
              geometry={nodes.lwing009.geometry}
              material={materials.Material}
              position={[1.16, 0, 0]}
            />
            <mesh
              name="body009"
              castShadow
              receiveShadow
              geometry={nodes.body009.geometry}
              material={materials.Material}
              position={[-0.09, 0, -1.68]}
              scale={5.88}
            />
            <mesh
              name="rwing009"
              castShadow
              receiveShadow
              geometry={nodes.rwing009.geometry}
              material={materials.Material}
              position={[-1.35, 0, 0]}
            />
          </group>
          <group name="Bird010" position={[-53.9, 3.67, -63.4]}>
            <mesh
              name="rwing010"
              castShadow
              receiveShadow
              geometry={nodes.rwing010.geometry}
              material={materials.Material}
              position={[-1.35, 0, 0]}
            />
            <mesh
              name="lwing010"
              castShadow
              receiveShadow
              geometry={nodes.lwing010.geometry}
              material={materials.Material}
              position={[1.16, 0, 0]}
            />
            <mesh
              name="body010"
              castShadow
              receiveShadow
              geometry={nodes.body010.geometry}
              material={materials.Material}
              position={[-0.09, 0, -1.68]}
              scale={5.88}
            />
          </group>
          <group
            name="Bird011"
            position={[56.69, 7.47, -78.82]}
            rotation={[0, -0.17, 0]}
          >
            <mesh
              name="rwing011"
              castShadow
              receiveShadow
              geometry={nodes.rwing011.geometry}
              material={materials.Material}
              position={[-1.35, 0, 0]}
            />
            <mesh
              name="lwing011"
              castShadow
              receiveShadow
              geometry={nodes.lwing011.geometry}
              material={materials.Material}
              position={[1.16, 0, 0]}
            />
            <mesh
              name="body011"
              castShadow
              receiveShadow
              geometry={nodes.body011.geometry}
              material={materials.Material}
              position={[-0.09, 0, -1.68]}
              scale={5.88}
            />
          </group>
          <group
            name="Bird012"
            position={[115.38, -10.44, -115.38]}
            rotation={[-0.02, -0.04, -0.01]}
          >
            <mesh
              name="lwing012"
              castShadow
              receiveShadow
              geometry={nodes.lwing012.geometry}
              material={materials.Material}
              position={[1.16, 0, 0]}
            />
            <mesh
              name="rwing012"
              castShadow
              receiveShadow
              geometry={nodes.rwing012.geometry}
              material={materials.Material}
              position={[-1.35, 0, 0]}
            />
            <mesh
              name="body012"
              castShadow
              receiveShadow
              geometry={nodes.body012.geometry}
              material={materials.Material}
              position={[-0.09, 0, -1.68]}
              scale={5.88}
            />
          </group>
        </group>
      </Float>
    </group>
  );
}

useGLTF.preload("/bird.glb");
